import Common from "../../Common";

const SoundFile = class extends Common {
	async browse(companyId?: id, queryParams?: { exclude_personal: "1" | "0"}) {
		if(companyId) {
			return this.get(`/company/${companyId}/soundfile`, queryParams);
		}

		return this.get(`/company/soundfile`, queryParams);
	}
}

export default SoundFile
